import { createFileRoute } from "@tanstack/react-router"

import { marketingPages } from "@/lib/marketing-pages"
import { seoMeta } from "@/lib/seo"

import { SessionsBenefitsSection } from "./-components/SessionsBenefitsSection"
import { SessionsBlogLinksSection } from "./-components/SessionsBlogLinksSection"
import { SessionsCalloutSection } from "./-components/SessionsCalloutSection"
import { SessionsChartSection } from "./-components/SessionsChartSection"
import { SessionsCtaSection } from "./-components/SessionsCtaSection"
import { SessionsFeaturesSection } from "./-components/SessionsFeaturesSection"
import { SessionsPreviewSection } from "./-components/SessionsPreviewSection"
import { SessionsPrivacySection } from "./-components/SessionsPrivacySection"
import { SessionsResumeSection } from "./-components/SessionsResumeSection"
import { SessionsTitleSection } from "./-components/SessionsTitleSection"

export const Route = createFileRoute("/features/sessions/")({
  head: () =>
    seoMeta({
      title: "Sessions",
      description: marketingPages["/features/sessions"].description,
      url: "https://entire.com/features/sessions",
      image: "/images/og/sessions.png",
      imageAlt: "Entire Sessions",
    }),
  component: SessionsPage,
})

function SessionsPage() {
  return (
    <>
      <SessionsTitleSection />
      <SessionsBenefitsSection />
      <SessionsPreviewSection />
      <SessionsCalloutSection />
      <SessionsFeaturesSection />
      <SessionsPrivacySection />
      <SessionsResumeSection />
      <SessionsChartSection />
      <SessionsCtaSection />
      <SessionsBlogLinksSection />
    </>
  )
}
